import React from 'react';

import { Container } from './styled';

const CircularLoading: React.FC = () => <Container />;

export default CircularLoading;
